import { Fragment, useState } from 'react'
import { Button, Card, CardBody, Modal } from 'react-bootstrap'
import { getLabelTipoBilancia } from '../../utils/utils'
import dayjs from 'dayjs'
import 'react-calendar/dist/Calendar.css'
import StickyTable from '../../components/StickyTable'
import { useInterventiListInfinite } from '../../hooks/interventi'

interface ModalConfirmProps {
  isOpen: boolean
  toggle: () => void
  save: (values: any) => Promise<void>
  title?: string
  isOpenConfirm?: boolean
  isPending?: boolean
}

export default function ModalInterventiEsportazione({
  isOpen,
  toggle,
  save,
  title,
  isOpenConfirm = false,
  isPending,
}: ModalConfirmProps) {
  const {
    data: interventi,
    hasNextPage,
    fetchNextPage,
  } = useInterventiListInfinite({
    tipo_intervento: 'verifica_periodica',
    stato: 'riesaminato',
    not_in_esportazione: 'true',
    esito_riesame: 'conforme',
    page_size: '1000',
  })

  const [interventiSelected, setSelectedInterventi] = useState<number[]>([])
  return (
    <>
      <Modal
        show={isOpen}
        onHide={toggle}
        centered
        size="lg"
        backdropClassName="backdrop-high"
        // if isOpenConfirm is true the modal is in overlay mode
        style={{
          zIndex: isOpenConfirm ? 1050 : 1060,
        }}
      >
        <Modal.Header className="">
          <Modal.Title>{title ?? 'Modifica interventi'}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: 'calc(100vh - 200px)',
            overflowY: 'auto',
            minHeight: 'calc(100vh - 200px)',
          }}
        >
          <div className="row">
            <div className="col-md-12">
              <div className="heading-h5">Elenco interventi certificati</div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-12">
              <Card>
                <CardBody>
                  <StickyTable
                    className="StickyInModal"
                    onEndReached={hasNextPage ? fetchNextPage : undefined}
                  >
                    <thead className="position-sticky top-0 bg-white">
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedInterventi(
                                  interventi?.pages
                                    ?.map((pagina) =>
                                      pagina.results.map(
                                        (bilancia) => bilancia.id
                                      )
                                    )
                                    .flat() ?? []
                                )
                              } else {
                                setSelectedInterventi([])
                              }
                            }}
                            checked={
                              interventiSelected.length ===
                              (
                                interventi?.pages
                                  ?.map((pagina) =>
                                    pagina.results.map(
                                      (bilancia) => bilancia.id
                                    )
                                  )
                                  .flat() ?? []
                              ).length
                            }
                          />
                        </th>
                        <th>Numero prenotazione</th>
                        <th>Bilancia</th>
                        <th>Cliente</th>
                        <th>Provincia</th>
                        <th>Data intervento</th>
                        <th>Esito</th>
                      </tr>
                    </thead>
                    <tbody style={{ maxHeight: '300px', overflowY: 'auto' }}>
                      {interventi?.pages?.length === 0 && (
                        <tr>
                          <td colSpan={5} className="text-center">
                            Nessun intervento da esportare
                          </td>
                        </tr>
                      )}
                      {interventi?.pages?.map((pagina, i) => (
                        <Fragment key={i}>
                          {pagina.results.map((intervento) => (
                            <tr key={intervento.id}>
                              <td className="p-md">
                                <input
                                  type="checkbox"
                                  checked={interventiSelected.includes(
                                    intervento.id
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedInterventi([
                                        ...interventiSelected,
                                        intervento.id,
                                      ])
                                    } else {
                                      setSelectedInterventi(
                                        interventiSelected.filter(
                                          (id) => id !== intervento.id
                                        )
                                      )
                                    }
                                  }}
                                />
                              </td>
                              <td>{intervento.numero_prenotazione}</td>
                              <td>
                                {intervento.bilancia_data?.matricola}{' '}
                                {intervento.bilancia_data?.sigla
                                  ? `(${intervento.bilancia_data?.sigla})`
                                  : ''}{' '}
                                -{' '}
                                {getLabelTipoBilancia(
                                  intervento.bilancia_data?.tipo_bilancia
                                )}
                              </td>
                              <td>
                                {
                                  intervento.nome_cliente
                                }
                              </td>
                              <td>
                                {
                                  intervento.provincia
                                }
                              </td>
                              <td>
                                {dayjs(intervento.data_intervento).format(
                                  'DD/MM/YYYY'
                                )}
                              </td>
                              <td>
                                {intervento.esito === 'positivo' ? (
                                  <span className="text-success material-icons">
                                    check
                                  </span>
                                ) : (
                                  <span className="text-danger material-icons">
                                    close
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </Fragment>
                      ))}
                    </tbody>
                  </StickyTable>
                </CardBody>
              </Card>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end">
          <Button type="button" onClick={toggle} variant="outline-secondary">
            Chiudi
          </Button>
          <Button
            type="button"
            variant="secondary"
            disabled={(interventiSelected.length === 0 && !title) || isPending}
            className="text-white"
            onClick={() =>
              save({
                interventi: interventiSelected,
              })
            }
          >
            Salva
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
